// extracted by mini-css-extract-plugin
module.exports = {"leftLabel":"barChart_leftLabel__380vV","rightLabel":"barChart_rightLabel__30x0Q","xAxisLabel":"barChart_xAxisLabel__3dCxt"};